var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewSwitchIconGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 32,
    viewBox: "0 0 63 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H31.5V31.5H5C2.51472 31.5 0.5 29.4853 0.5 27V5Z",
    fill: "#6C8EA5",
    fillOpacity: 0.42,
    stroke: "#6C8EA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23V21H25V23H7ZM7 19V17H25V19H7ZM7 15V13H25V15H7ZM7 11V9H25V11H7Z",
    fill: "#406074"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0.5H58C60.4853 0.5 62.5 2.51472 62.5 5V27C62.5 29.4853 60.4853 31.5 58 31.5H31.5V0.5Z",
    fill: "#6C8EA5",
    fillOpacity: 0.17,
    stroke: "#6C8EA5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16C45.9 16 44.9583 15.6083 44.175 14.825C43.3917 14.0417 43 13.1 43 12C43 10.9 43.3917 9.95833 44.175 9.175C44.9583 8.39167 45.9 8 47 8C48.1 8 49.0417 8.39167 49.825 9.175C50.6083 9.95833 51 10.9 51 12C51 13.1 50.6083 14.0417 49.825 14.825C49.0417 15.6083 48.1 16 47 16ZM39 24V21.2C39 20.6333 39.1458 20.1125 39.4375 19.6375C39.7292 19.1625 40.1167 18.8 40.6 18.55C41.6333 18.0333 42.6833 17.6458 43.75 17.3875C44.8167 17.1292 45.9 17 47 17C48.1 17 49.1833 17.1292 50.25 17.3875C51.3167 17.6458 52.3667 18.0333 53.4 18.55C53.8833 18.8 54.2708 19.1625 54.5625 19.6375C54.8542 20.1125 55 20.6333 55 21.2V24H39ZM41 22H53V21.2C53 21.0167 52.9542 20.85 52.8625 20.7C52.7708 20.55 52.65 20.4333 52.5 20.35C51.6 19.9 50.6917 19.5625 49.775 19.3375C48.8583 19.1125 47.9333 19 47 19C46.0667 19 45.1417 19.1125 44.225 19.3375C43.3083 19.5625 42.4 19.9 41.5 20.35C41.35 20.4333 41.2292 20.55 41.1375 20.7C41.0458 20.85 41 21.0167 41 21.2V22ZM47 14C47.55 14 48.0208 13.8042 48.4125 13.4125C48.8042 13.0208 49 12.55 49 12C49 11.45 48.8042 10.9792 48.4125 10.5875C48.0208 10.1958 47.55 10 47 10C46.45 10 45.9792 10.1958 45.5875 10.5875C45.1958 10.9792 45 11.45 45 12C45 12.55 45.1958 13.0208 45.5875 13.4125C45.9792 13.8042 46.45 14 47 14Z",
    fill: "#6C8EA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSwitchIconGrid);
export default __webpack_public_path__ + "static/media/ViewSwitchIconGrid.e652906f11fe07a2b94cd0fd3a08ea11.svg";
export { ForwardRef as ReactComponent };